import { BrowserRouter as Router, Route } from 'react-router-dom';
import React from 'react';
import AppLayout from './AppLayout';
import './App.scss';

const AppRouter = () => (
    <div className="point-of-care-app">
        <Router>
            <Route render={(props) => <AppLayout {...props} />} />
        </Router>
    </div>
);

export default AppRouter;
